"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReportBugWrapper = function ReportBugWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "message", _descriptor, _this);
      _initializerDefineProperty(_this, "email", _descriptor2, _this);
      _initializerDefineProperty(_this, "image", _descriptor3, _this);
      _initializerDefineProperty(_this, "displaySubmittedMessage", _descriptor4, _this);
      _initializerDefineProperty(_this, "submitting", _descriptor5, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "disabled",
      get: function get() {
        return (0, _utils.isBlank)(this.message) || this.requiresEmailAddress && !(0, _utils.isValidEmail)(this.email);
      }
    }, {
      key: "requiresEmailAddress",
      get: function get() {
        var _AppUI$user, _AppUI$user2, _AppUI$user3;
        return ((_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.guest) || ((_AppUI$user2 = _state.AppUI.user) === null || _AppUI$user2 === void 0 || (_AppUI$user2 = _AppUI$user2.email) === null || _AppUI$user2 === void 0 ? void 0 : _AppUI$user2.match('privaterelay.appleid')) || ((_AppUI$user3 = _state.AppUI.user) === null || _AppUI$user3 === void 0 || (_AppUI$user3 = _AppUI$user3.email) === null || _AppUI$user3 === void 0 ? void 0 : _AppUI$user3.match('apple.com'));
        ;
      }
    }, {
      key: "onSubmit",
      value: function onSubmit(params) {
        if (!this.disabled) {
          this.submitting = true;
          var debugInfo = _objectSpread(_objectSpread({}, _state.DeckUI.debugInfo), {}, {
            bugType: params.bugType,
            timestamp: new Date().toISOString(),
            appVersion: params.mobileVersion || params.webVersion,
            platform: params.deviceType,
            dimensions: params.dimensions
          });
          _state.AppUI.contactMessageStore.create({
            data: {
              webVersion: params.webVersion,
              mobileVersion: params.mobileVersion,
              deviceType: params.deviceType,
              deviceLanguageId: _state.AppUI.targetLanguageId,
              message: this.message,
              email: (0, _utils.isPresent)(this.email) ? this.email : _state.AppUI.user.email,
              debug_info: debugInfo,
              image_url: this.image && this.image.url,
              logs: params.logs
            }
          }, this.afterSubmit);
        }
      }
    }, {
      key: "afterSubmit",
      value: function afterSubmit() {
        var _this2 = this;
        this.onReset();
        this.submitting = false;
        this.displaySubmittedMessage = true;
        setTimeout(function () {
          return _this2.displaySubmittedMessage = false;
        }, 5000);
      }
    }, {
      key: "onReset",
      value: function onReset() {
        this.message = '';
        this.image = null;
      }
    }, {
      key: "setMessage",
      value: function setMessage(message) {
        this.message = message;
      }
    }, {
      key: "setImage",
      value: function setImage(image) {
        this.image = image;
      }
    }, {
      key: "setEmail",
      value: function setEmail(email) {
        this.email = email;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          message: this.message,
          setMessage: this.setMessage,
          requiresEmailAddress: this.requiresEmailAddress,
          disabled: this.disabled,
          onSubmit: this.onSubmit,
          onReset: this.onReset,
          image: this.image,
          setImage: this.setImage,
          setEmail: this.setEmail,
          email: this.email,
          submitting: this.submitting,
          displaySubmittedMessage: this.displaySubmittedMessage
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "email", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "image", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "displaySubmittedMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "submitting", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "disabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "requiresEmailAddress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "requiresEmailAddress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSubmit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterSubmit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onReset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onReset"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setMessage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setImage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setImage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setEmail", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setEmail"), _class2.prototype), _class2)) || _class;
};
ReportBugWrapper.displayName = 'ReportBugWrapper';
var _default = exports["default"] = ReportBugWrapper;